// extracted by mini-css-extract-plugin
module.exports = {"className":"textHeadingL_className__KQ29Z"};